import TopAnime from "./TopAnime/TopAnime";

const Top = (props) => {

  return (
    <div>
      <TopAnime  />
    </div>
  );
};

export default Top;
